// src/utils/facture.js

export const generateFactureTemplate = (factureData) => {
  return `
  <!DOCTYPE html>
  <html lang="fr">
  <head>
    <meta charset="UTF-8">
    <title>Facture</title>
    <style>
      @media screen and (max-width: 480px) {
        .container { width: 100% !important; }
        .padding { padding: 15px !important; }
        .title { font-size: 18px !important; }
        .text { font-size: 13px !important; }
        .total { font-size: 16px !important; }
      }
    </style>
  </head>
  <body style="margin:0;padding:0;background:#f5f5f5;">

    <table width="100%" cellpadding="0" cellspacing="0" style="background:#f5f5f5;padding:20px;">
      <tr>
        <td align="center">

          <table class="container" width="50%" cellpadding="0" cellspacing="0" style="max-width:600px;background:#ffffff;border-radius:8px;overflow:hidden;">
            
            <tr>
              <td class="padding" style="padding:20px;text-align:center;border-bottom:1px solid #eaeaea;">
                <img src="${factureData.logo}" width="120" alt="Logo" style="display:block;margin:0 auto 10px auto;" />
                <h2 class="title" style="font-family:Arial,  Helvetica, sans-serif;color:#2c3e50;font-weight:600;">
                  Facture ${factureData.factureTitre}
                </h2>
              </td>
            </tr>

            <tr>
              <td class="padding text" style="padding:20px;font-family:Arial, Helvetica, sans-serif;font-size:14px;color:#555555;line-height:1.6;">
                <strong style="color:#2c3e50;">Client :</strong> ${factureData.factureUtilisateur}<br>
                <strong style="color:#2c3e50;">Référence :</strong> ${factureData.factureReference}<br>
                <strong style="color:#2c3e50;">Date :</strong> ${factureData.factureDate}
              </td>
            </tr>

            <tr>
              <td class="padding" style="padding:0 20px 20px 20px;">
                <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse:collapse;font-family:Arial, Helvetica, sans-serif;">
                  <tr style="background:#f0f2f5;">
                    <th style="padding:12px;border:1px solid #dddddd;text-align:left;font-size:14px;color:#2c3e50;">Produit</th>
                    <th style="padding:12px;border:1px solid #dddddd;text-align:right;font-size:14px;color:#2c3e50;">Montant</th>
                  </tr>
                  <tr>
                    <td style="padding:12px;border:1px solid #dddddd;font-size:14px;color:#555555;">${factureData.factureProduits}</td>
                    <td style="padding:12px;border:1px solid #dddddd;text-align:right;font-size:14px;color:#555555;">${factureData.factureTotal}</td>
                  </tr>
                </table>
              </td>
            </tr>

            <tr>
              <td class="padding" style="padding:20px;text-align:right;font-family:Arial, Helvetica, sans-serif;background:#fafafa;">
                <span class="total" style="font-size:18px;font-weight:bold;color:#1f6fe5;">
                  Total : ${factureData.factureTotal2}
                </span>
              </td>
            </tr>

            <tr>
              <td style="padding:15px;text-align:center;font-family:Arial, Helvetica, sans-serif;font-size:12px;color:#999999;background:#ffffff;border-top:1px solid #eaeaea;">
                © Deal — Facture électronique
              </td>
            </tr>

          </table>
        </td>
      </tr>
    </table>

  </body>
  </html>
  `;
};
